const isUsingEmulators =
  window.location.host.includes('localhost') && process.env.REACT_APP_FIREBASE_EMULATORS === 'true';

export const appConfig = {
  isUsingEmulators,
  cloudFunctionsUri: isUsingEmulators
    ? 'http://localhost:5001/code-rma-app-dev/europe-west1'
    : process.env.REACT_APP_CLOUD_FUNCTIONS_URI,
};
